<template>
    <div class="settingsBarMenuItem">
        <router-link :to="route">
            <div class="row menu-item" :class="activeClass">
                <i class="material-icons">{{icon}}</i>
                <p>{{title}}</p>
            </div>
        </router-link>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'settingsBarMenuItem',
    mixins: [
        Default
    ],
    props: ['title', 'icon', 'route'],
    data() {
        return {
            activeClass: ''
        };
    },
    watch: {
        $route: function(newVal, oldVal) {
            this.updateActiveClass();
        }
    },
    mounted() {
        this.updateActiveClass();
    },
    methods: {
        updateActiveClass: function() {
            this.activeClass = this.$route.path.indexOf(this.route.path) !== -1 ? 'active' : '';
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .settingsBarMenuItem {
        .menu-item {
            padding: 15px 30px;
            font-size: 16px;
            color: #454D5A;

            $active-color: #D6DCE6;
            &.active {
                background-color: $active-color;
            }

            &:hover {
                background-color: $active-color;
                transition: background-color 0.1s;
            }

            i {
                padding: 0 35px 0 15px;
            }
        }
    }
</style>
